<template src="./index.html">
</template>
<script>
import {wpsr_getbm_api} from "@/api/wpsr";
	export default {
		name: '',
		components: {},
		props: {
			invoicediag: {
				type: Boolean,
				default: false
			},
      invoicedata: {
        type: Object,
        default: () => ({})
      },
      svlmapping: {
        type: Array,
        default: () => ([])
      },
      xmlxdownlist: {
        type: Array,
        default: () => ([])
      },
      xiaofxx:{
        type: Object,
        default: () => ({})
      }
		},
    watch: {
      invoicediag: function(indexVal, oldVal) {
        if (indexVal) {
          this.init();
        }
      },
    },
		data: function() {
			return {
				choosedjindex: null,
				djdataitem: {},
        verifyInvoice:[
          {field:"bianh",title:"编号不能为空"},
          {field:"shourrq",title:"收入日期不能为空"},
          {field:"goufmc",title:"购方名称不能为空"}
          // {field:"goufsbh",title:"购方识别号不能为空"},
          // {field:"goufdzdh",title:"购方地址电话不能为空"},
          // {field:"goufkhh",title:"购买方开户行及账号"}
        ],
        verifyInvoiceDetails:[
          {field:"xianmlx",title:"项目类型不能为空"},
          {field:"xianmmc",title:"项目名称不能为空"},
          {field:"jine",title:"金额不能为空"},
          {field:"shuil",title:"税率不能为空"},
          {field:"shuie",title:"税额不能为空"}
        ],
        sortSlvList:[], //排序好的税率下拉集合,
        hansjeda:"" //含税金额大写
      };
		},
		created() {},
		methods: {
      init(){
        if(!this.invoicedata || !this.invoicedata.bianh){ //没有编号重新生成编号
          this.getbh();
        }
        if(!this.invoicedata.mx || this.invoicedata.mx.length < 1){
          this.invoicedata.mx = [];
          this.foraddup();
        }
        if(!this.invoicedata.id && this.xiaofxx){
          this.loadxiaofxx();
        }
        this.computeHj();
        this.sortSlv();
      },
      //冒泡排序
      sortSlv(){
        let svlList = new Array();
        for(let i in this.svlmapping){
          let param = {
            label : i,
            value : this.svlmapping[i]
          }
          svlList.push(param);
        }
        //先排倒叙再反转 ， 免税 和 0税率才能正常显示
        svlList.sort((a,b) =>  b.value - a.value );
        svlList.reverse();

        this.sortSlvList = JSON.parse(JSON.stringify(svlList));
      },
			forchoosemove(index) {
				if (this.choosedjindex != index) {
					this.choosedjindex = index
				}
			},
      //加载销方信息
      loadxiaofxx(){
        this.invoicedata.xiaofsbh = this.xiaofxx.nsrsbh;
        this.invoicedata.xiaofmc = this.xiaofxx.nsrmc;
        this.invoicedata.xiaofdzdh = this.xiaofxx.zhucdz + " " + this.xiaofxx.dianhhm;
        this.invoicedata.xiaofkhh = this.xiaofxx.kaihyh + " " + this.xiaofxx.kaihyhzh;
        this.invoicedata = JSON.parse(JSON.stringify(this.invoicedata));
      },
			// closediag(){
			// 	this.$emit("closediag","")
			// },
			foraddup(index) {
				let item = JSON.parse(JSON.stringify(this.djdataitem));
				this.invoicedata.mx.splice(index, 0, item);
			},
			foradddown(index) {
				let item = JSON.parse(JSON.stringify(this.djdataitem));
        this.invoicedata.mx.splice(index + 1, 0, item);
			},
			forremove(item,index){
        if(this.invoicedata.mx.length < 2){
          return;
        }
				if(item.id){ //把删除的id传到后端
					if(this.invoicedata.deleteIds){
            this.invoicedata.deleteIds.push(item.id);
          } else {
            let ids = new Array();
            ids.push(item.id);
            this.invoicedata.deleteIds = ids;
          }
				}
        this.invoicedata.mx.splice(index , 1);
        this.computeHj();
			},
			closediag() {
				this.$emit("closediag", false)
			},
      //更新编号
			getbh(){
        wpsr_getbm_api({}).then(res => {
          if(res.data.code == 1){
            this.invoicedata.bianh = res.data.data;
            this.invoicedata = JSON.parse(JSON.stringify(this.invoicedata));
            //赋值
          } else {
            this.$message.error(res.data.msg);
          }
        })
      },
      //修改税率
      changeslv(e , index){
        e.shuil = this.svlmapping[e.shuilName];
        var newdata=JSON.parse(JSON.stringify(this.invoicedata.mx))
        this.invoicedata.mx  = newdata;
        this.computeShuie(e , index);
      },
      //修改金额
      changejine(e , index){
        this.computeShuie(e , index);
      },
      //计算税额
      computeShuie(e , index){
        let shuil = e.shuil;
        let jine = e.jine;
        if(shuil && jine){
          let shuie = (parseFloat(jine) * parseFloat(shuil)).toFixed(2);
          this.invoicedata.mx[index].shuie = shuie;
          var newdata=JSON.parse(JSON.stringify(this.invoicedata.mx))
          this.invoicedata.mx  = newdata;
          this.computeHj();
        }
      },
      //计算合计
      computeHj(){
        let hejje = 0;
        let hejse = 0;
        let jiashj = 0;
        if(this.invoicedata.mx && this.invoicedata.mx.length > 0){
          this.invoicedata.mx.forEach(i => {
              hejje += parseFloat(i.jine?i.jine : "0.00");
              hejse += parseFloat(i.shuie?i.shuie : "0.00");
          });
          jiashj = hejje + hejse;
        }
        this.invoicedata.weisje = hejje.toFixed(2);
        this.invoicedata.shuie = hejse.toFixed(2);
        this.invoicedata.hansje = jiashj.toFixed(2);
        this.hansjeda = this.$pricetonew(this.invoicedata.hansje);
        this.invoicedata  = JSON.parse(JSON.stringify(this.invoicedata));
      },
      submitInfo(){
        //校验参数必填
        try {
          this.verifyInvoice.forEach(item =>{
            if(!this.invoicedata[item.field]){
                throw new Error(item.title);
            }
          })
          if(this.invoicedata.mx){
            this.invoicedata.mx.forEach(item =>{
              this.verifyInvoiceDetails.forEach(i =>{
                if(!item[i.field]){
                  throw new Error(i.title);
                }
              })
            })
          }
        } catch (e) {
         this.$message.warning(e.message);
         return;
        }
        this.$emit("submit", this.invoicedata)
      }
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
